<!--<section [innerHTML]="branding"></section>-->
<section data-module="footer" data-view="index">
    <div class="row language_confirmation" [hidden]="!showLanguageConfirmation">
        <div class="container">
            <section>
                <div [innerHTML]="branding?.copy$$info_language_selector?.TEXT"></div>
                <div class="row">
                    <div class="col">
                        <a data-role="button" class="ui-link ui-btn ui-shadow ui-corner-all" (click)="switchingLanguage()">{{branding?.copy$$btn_language_selector?.TEXT}}</a>
                    </div>
                </div>
                  <button data-shadow="false" lang="en" type="button" class="close_button ui-btn-right ui-btn ui-corner-all" (click)="closeConfirmation()"></button>
            </section>
        </div>
    </div>
    <footer data-component="footer" class="row px-3">
        <section aria-label="Footer links" class="container" role="contentinfo">
            <article class="row">
              <div class="language-toggle-wrapper" *ngIf="!isMILAccount">
                  <button 
                    class="secondary-small"
                    role="button" 
                    #toggleButton (click)="switchingLanguage()" 
                    [innerHTML]="showLanguageConfirmation?branding?.copy$$btn_cancel_language_selector?.TEXT:branding?.copy$$btn_language_toggle?.TEXT" 
                    [attr.aria-label]="showLanguageConfirmation?branding?.copy$$btn_cancel_language_selector?.WCAG_TEXT:''"
                    >
                  </button>
              </div>
            </article>
            <article class="row">
               <div class="footer-disclaimer" *ngIf="!isMILAccount" id="footer-disclaimer" [innerHTML]="branding?.copy$$info_language_toggle_Preferences_footer?.TEXT"></div>
              <!-- <div class="right-aligned-elements" >                  
                      <div class="copyright" [innerHTML]="branding?.copy$$label_citigroup_copyright?.TEXT"></div>
                </div> -->
            </article>
            <article class="row">
                <div class="footer-link-wrapper" >
                    <div class="linkgroup">
                      <div class="d-lg-inline-block" *ngIf="branding?.cmlink$$link_privacy?.LINK_TEXT">
                          <a href="{{branding?.cmlink$$link_privacy?.URL.FULL_URL}}" target="_blank" [innerHTML]="branding?.cmlink$$link_privacy?.LINK_TEXT"></a>
                          <span class="sr-only">Link opens in a new window</span>
                      </div>
                      <span aria-hidden="true" data-aria-hidden="true">|</span>
                        
                        <!-- Link for Notice of Collection Placeholder -->
                      <div *ngIf="branding?.cmlink$$link_notice_at_collection?.LINK_TEXT">
                        <a href="{{branding?.cmlink$$link_notice_at_collection?.URL.FULL_URL}}" target="_blank" [innerHTML]="branding?.cmlink$$link_notice_at_collection?.LINK_TEXT"></a>
                        <span class="sr-only">Link opens in a new window</span>
                      </div>
                      <span aria-hidden="true" data-aria-hidden="true">|</span>
                      <!-- Link for CA Privacy Hub Placeholder -->
                      <div *ngIf="branding?.cmlink$$link_ca_privacy_hub?.LINK_TEXT">
                        <a href="{{branding?.cmlink$$link_ca_privacy_hub?.URL.FULL_URL}}" target="_blank" id = "privacyhubText" [innerHTML]="branding?.cmlink$$link_ca_privacy_hub?.LINK_TEXT"></a>
                        <span class="sr-only">Link opens in a new window</span>
                      </div>
                      <span aria-hidden="true" data-aria-hidden="true">|</span>
                      
                        <div *ngIf="branding?.cmlink$$link_accessibility?.LINK_TEXT">
                          <a href="{{branding?.cmlink$$link_accessibility?.URL.FULL_URL}}" target="_blank" [innerHTML]="branding?.cmlink$$link_accessibility?.LINK_TEXT"></a>
                          <span class="sr-only">Link opens in a new window</span>
                      </div>
                      <span aria-hidden="true" data-aria-hidden="true">|</span>
                      <div  *ngIf="branding?.cmlink$$link_site_terms?.LINK_TEXT">
                          <a href="{{branding?.cmlink$$link_site_terms?.URL.FULL_URL}}" target="_blank" [innerHTML]="branding?.cmlink$$link_site_terms?.LINK_TEXT"></a>
                          <span class="sr-only">Link opens in a new window</span>
                      </div>
                      <span aria-hidden="true" data-aria-hidden="true">|</span>
                      <div *ngIf="creditFAQEligible">
                            <a href="{{creditFAQUrl}}" target="_blank" [innerHTML]="branding?.cmlink$$link_credit_report_dispute?.LINK_TEXT"></a>
                            <span class="sr-only" id="creditReportDispute" [innerHTML]="branding?.cmlink$$link_credit_report_dispute?.WCAG_TEXT"></span>
                      </div>
                      <span aria-hidden="true" data-aria-hidden="true">|</span>
                      <div *ngIf="branding?.cmlink$$link_go_to_partner_site.LINK_TEXT">
                          <a 
                          popupModal
                          href="#"
                          [popupContentComponent] = "'popup-site-speedbump'"
                          class="partner_link"
                          id="partnerlinkText"
                          aria-labelledby="partnerlinkText partnerlinkADA">{{branding?.cmlink$$link_go_to_partner_site.LINK_TEXT}}
                        </a>
                        <span class="sr-only" id="partnerlinkADA" [innerHTML]="branding?.cmlink$$link_go_to_partner_site.WCAG_TEXT"></span>
                          <!-- <a popupModal
                            [popupContentComponent]="'popup-site-speedbump'"
                            class="partner_link"
                            href="#"
                            target="_blank"
                            [innerHTML]="branding?.cmlink$$link_go_to_partner_site?.LINK_TEXT">
                          </a>
                          <span class="sr-only">Link opens in a new window</span> -->
                        </div>                        
                      </div>
                      <div class="copyright" [innerHTML]="branding?.copy$$label_citigroup_copyright?.TEXT"></div>
                       <!-- <div>
                  <a class="secure_norton" href="{{branding?.cmlink$$link_verisign?.URL.FULL_URL}}" target="_blank">
                  <span class="sr-only">Norton Secured?Powered by VeriSign. Link opens in a new window</span>
                  </a>
                </div> -->
                    </div>
            </article>
            <scroll-to-top [pageData]='pageData'></scroll-to-top>
        </section>
    </footer>
</section>
